/**
 * Header Component
 * 
 * Displays the main header with logo, title, and feature highlight.
 */

import '../styles/Header.css'

function Header() {
  return (
    <header className="header" role="banner">
      <div className="container">
        <h1 className="header-title">
          <i className="fas fa-credit-card" aria-hidden="true"></i>
          ONLINE-KREDIT
        </h1>
        <p className="header-subtitle">
          Kreditkarte ohne Antragsgebühren, nur Kartengebühren
        </p>
        <p className="header-feature">
          <i className="fas fa-check-circle" aria-hidden="true"></i>
          Kreditkarte auch für Menschen mit Schulden
        </p>
      </div>
    </header>
  )
}

export default Header
